export var RankedIdentifiersType;
(function (RankedIdentifiersType) {
    RankedIdentifiersType[RankedIdentifiersType["BILL_OF_LADING"] = 0] = "BILL_OF_LADING";
    RankedIdentifiersType[RankedIdentifiersType["BOOKING_NUMBER"] = 1] = "BOOKING_NUMBER";
    RankedIdentifiersType[RankedIdentifiersType["CONTAINER_ID"] = 2] = "CONTAINER_ID";
    RankedIdentifiersType[RankedIdentifiersType["ORDER"] = 3] = "ORDER";
    RankedIdentifiersType[RankedIdentifiersType["PRO"] = 4] = "PRO";
    RankedIdentifiersType[RankedIdentifiersType["TRACKING_NUMBER"] = 5] = "TRACKING_NUMBER";
    RankedIdentifiersType[RankedIdentifiersType["AIR_WAYBILL"] = 6] = "AIR_WAYBILL";
    RankedIdentifiersType[RankedIdentifiersType["HOUSE_AIR_WAYBILL"] = 7] = "HOUSE_AIR_WAYBILL";
    RankedIdentifiersType[RankedIdentifiersType["RAIL_CAR_ID"] = 8] = "RAIL_CAR_ID";
    RankedIdentifiersType[RankedIdentifiersType["SERIAL_NUMBER"] = 9] = "SERIAL_NUMBER";
    RankedIdentifiersType[RankedIdentifiersType["WAYBILL"] = 10] = "WAYBILL";
    RankedIdentifiersType[RankedIdentifiersType["TRAIN_NUMBER"] = 11] = "TRAIN_NUMBER";
    RankedIdentifiersType[RankedIdentifiersType["VEHICLE_IDENTIFICATION_NUMBER"] = 12] = "VEHICLE_IDENTIFICATION_NUMBER";
    RankedIdentifiersType[RankedIdentifiersType["WAGON_ID"] = 13] = "WAGON_ID";
    RankedIdentifiersType[RankedIdentifiersType["UNKNOWN"] = 14] = "UNKNOWN";
})(RankedIdentifiersType || (RankedIdentifiersType = {}));
